import { DateRangeSchema } from 'common/hooks/customSearchParams';
import { DateInput } from 'components/tailwind-ui/DateInput';
import moment from 'moment';
import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import { DEFAULT_DATE_RANGE_PARAM } from 'pages/Shipments/params';
import * as React from 'react';

export type Date = moment.Moment | null;

interface FilterStates {
  startDate: Date;
  endDate: Date;
}

interface Props {
  field: string;
  filterStates: FilterStates;
}

export const DateRangeOptions: React.FC<Props> = (props) => {
  const { field, filterStates } = props;
  const { setSearchParams } = useFilterSearchParams(true);

  const handleDateChange = (date: Date, kind: 'start' | 'end') => {
    let startDate = filterStates.startDate || null;
    let endDate = filterStates.endDate || null;

    switch (kind) {
      case 'start':
        if (date && endDate && date.isAfter(endDate)) {
          endDate = null;
        }
        startDate = date;
        break;
      case 'end':
        if (date && startDate && date.isBefore(startDate)) {
          startDate = null;
        }
        endDate = date;
        break;
      default:
        break;
    }

    const value: DateRangeSchema = { ...DEFAULT_DATE_RANGE_PARAM, startDate, endDate };

    setSearchParams({
      [field]: value,
    });

    return true;
  };

  return (
    <>
      <DateInput
        label="Start Date"
        date={filterStates.startDate}
        onChange={(date) => handleDateChange(date, 'start')}
        checked={!!filterStates.startDate}
        style={{ marginLeft: 0, marginRight: 32 }}
      />
      <DateInput
        label="End Date"
        date={filterStates.endDate}
        onChange={(date) => handleDateChange(date, 'end')}
        checked={!!filterStates.endDate}
        style={{ marginLeft: 0, marginRight: 32 }}
      />
    </>
  );
};
DateRangeOptions.displayName = 'Filters.More.DateRangeOptions';
